import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const Menu = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    description,
    dmId = 'dm-menu',
    pointerEvents = 'none',
    secondColor,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.menu.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="M3.44842827,17.0010968 L3.58545181,17.0060866 L16.4547608,17.0060866 C17.2146946,17.0701802 17.7995517,17.7201096 17.7995517,18.5005016 C17.7995517,19.2808935 17.2146946,19.9308229 16.4547608,19.9949166 L16.4547608,19.9949166 L3.58545181,19.9949166 C3.0350802,20.0413355 2.50596174,19.7670863 2.21684075,19.2855471 C1.92771975,18.8040079 1.92771975,18.1969953 2.21684075,17.7154561 C2.50596174,17.2339169 3.0350802,16.9596676 3.58545181,17.0060866 Z M12.4701953,11.0030094 C13.2875767,11.0030094 13.9501953,11.665628 13.9501953,12.4830094 L13.9501953,12.5220063 C13.9501953,13.3393877 13.2875767,14.0020063 12.4701953,14.0020063 L3.55083313,14.0020063 C2.7334517,14.0020063 2.07083313,13.3393877 2.07083313,12.5220063 L2.07083313,12.4830094 C2.07083313,11.665628 2.7334517,11.0030094 3.55083313,11.0030094 L12.4701953,11.0030094 Z M20.4145482,5 L20.4145482,5.04989983 C20.9649198,5.00417575 21.4940383,5.27431968 21.7831593,5.74865065 C22.0722802,6.22298162 22.0722802,6.82090773 21.7831593,7.2952387 C21.4940383,7.76956967 20.9649198,8.03971359 20.4145482,7.99398952 L20.4145482,7.99398952 L3.58545181,7.99398952 C2.76535299,7.99398952 2.10053154,7.32376214 2.10053154,6.49699476 C2.10053154,5.67022738 2.76535299,5 3.58545181,5 L3.58545181,5 L20.4145482,5 Z"
      />
    </IconSvg>
  );
};

export default memo(Menu);
